<template>
    <div class="level2-page">
        <div class='topBanner'>
            <TopBar :changeBg="true"/>
            <div class='piclist' v-for="(item, index) in config.picList" :key="index">
                <div class='pic' :style="{backgroundImage :`url(${item.bgimage || ''})`, height: item.height, backgroundColor: item.bgcolor, paddingTop: item.paddingTop, paddingBottom: item.paddingBottom}" v-if="!item.isvideo" >
                    <img :src="item.image" v-if="item.image">
                </div>
                <!-- <img :src="item.image" v-if="item.image && !item.video"> -->
                <video id='videoId' width="591" height="332" controls :poster="viewImage(item.image, 591, 332)" v-else>
                    <source :src="item.video" type="video/mp4">
                    您的浏览器不支持video标签。
                </video>
            </div>
        </div>
        <div class='example' :style="{backgroundColor: config.bgColor}" v-if="config.example && config.example.length > 0">
            <Title>成功合作案例</Title>
            <Examples :list="config.example" :size='3' :bgColor="config.bgColor"/>
        </div>
        <FootBar/>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import FootBar from '@components/footBar'
import TopBar from '@components/topBar'
import Title from '@components/title/level2Title'
import Banner from '../home/components/banner'
import Enter from '../home/components/enter'
import Examples from './examples'
import { util } from '@utils'

export default {
    data() {
        return {
            config: []
        }
    },
    async created() {
        this.$store.dispatch('getUserInfo')
        this.$store.dispatch('pages/home/getCmsHome')
        const type = this.$route.query.type
        const res = await this.$store.dispatch('level2/getCMSConfig')
        const config = res.data || {}
        this.config = config[type]
    },
    methods: {
        viewImage(value, width, height) {
            return util.viewImage(value, width, height)
        }
    },
    components: {
        TopBar,
        FootBar,
        Banner,
        Enter,
        Title,
        Examples
    }
}
</script>
<style lang="scss" scoped>
.level2-page{
    .topBanner{
        position: relative;
    }
    img{
        width: 100%;
        max-height: 100%;
    }
    .warp-text{
        height: 114px;
        line-height: 114px;
        text-align: center;
        background-color:#e4e4e4;
    }
    .level2-title{
        text-align: center;
        width: 100%;
    }
    .warp-enter{
        margin-top: 36px;
    }
    .piclist{
        text-align: center;

        video{
            margin-top:63px;
            margin-bottom: 71px;
            border-radius: 10px;
        }

        .pic{
            background-repeat: no-repeat;
            background-position: 50%;
            background-size: auto;

            img{
                width: auto;
                height: 100%;
            }
        }
        @media screen and (min-width: 1980px) {
            .pic {
                background-repeat: no-repeat;
                background-position: bottom;
                background-size: 100%;
            }
        }
    }
}
</style>
